export default theme => ({
  root: {
    padding: 0,
    '& .MuiListItem-root > .MuiSvgIcon-root': {
      width: 14,
      height: 14
    },
    // Target child items specifically (items inside the collapsed list)
    '& .MuiCollapse-root .MuiList-root .MuiListItemButton-root': {
      paddingLeft: theme.spacing(4),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      minHeight: 36, // Reduce minimum height
      '& .MuiListItemText-root': {
        '& .MuiListItemText-primary': {
          fontSize: '0.8125rem', // 13px
          fontWeight: 400,
          lineHeight: 1.2
        }
      }
    }
  },
  icon: {
    marginLeft: theme.spacing(0.5),
    minWidth: 32,
    width: 32,
    '& .MuiSvgIcon-root': {
      width: 18,
      height: 18
    },
    // Make child item icons smaller
    '.MuiCollapse-root .MuiList-root &': {
      minWidth: 26,
      width: 26,
      '& .MuiSvgIcon-root': {
        width: 15,
        height: 15
      }
    }
  }
});
